import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["CMPProvider"] */ "/app/apps/royalur/src/components/cookie/CMPProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MatomoProvider"] */ "/app/apps/royalur/src/components/Matomo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReactQueryProvider"] */ "/app/apps/royalur/src/components/ReactQueryProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/components/font/interFont.ts\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"interFont\"}");
;
import(/* webpackMode: "eager", webpackExports: ["AccessibilityProvider"] */ "/app/packages/web_components/src/accessibility/AccessibilityContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ToastContainer"] */ "/app/packages/web_components/src/feedback/toast/ToastContainer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ToastProvider"] */ "/app/packages/web_components/src/feedback/toast/ToastContext.tsx");
